import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const SnackbarWarning = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 16 16" sx={{ height: '16px', width: '16px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_6493_9740)">
        <path
          d="M7.99992 5.3335V8.00016M7.99992 10.6668H8.00659M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z"
          stroke="#FF9E1F"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6493_9740">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default SnackbarWarning;
